import React, { useEffect } from 'react';
import { Avatar, Banner } from '@stashinvest/react-components';
import { KeyIcon } from '@stashinvest/react-assets';
import { useBanjo } from '@stashinvest/react-banjo';
import { STASH_WORKS_WEB_PATH } from 'stash/constants';
import { useStashWorksStatus } from 'stash/hooks/stashWorks';
import useTrack from 'stash/hooks/useTrack';
import { Origin, StashWorks_Clicked, UserProfile_Viewed } from '@stashinvest/product-events-typescript';


const StashWorksBanner = () => {
	const { getString } = useBanjo();
	const { hasStashWorks, isLoading } = useStashWorksStatus();
	const track = useTrack();
	const handleBannerClick = () => {
		track(StashWorks_Clicked.v1({ origin: Origin?.userProfile }));
		window.location.href = STASH_WORKS_WEB_PATH;
	};

	useEffect(() => {
		if (!isLoading) {
			track(UserProfile_Viewed.v1({ stashworks_banner: hasStashWorks ? 'yes' : 'no' }));
		}
	}, [hasStashWorks, isLoading, track]);

	return isLoading ? (
		<></>
	) : (
		hasStashWorks && (
			<div className="w-full gridMedium:w-3/4 mx-auto">
				<Banner
					onClick={handleBannerClick}
					variant={{
						avatar: (
							<Avatar
								backgroundType="fill"
								shape="square"
								variant={{
									Icon: KeyIcon,
									size: 'small',
									type: 'icon',
									variant: 'neutral',
								}}
							/>
						),
						text: getString('action/startTask/goToStashWorks'),
						type: 'default',
					}}
				/>
			</div>
		)
	);
};

export default StashWorksBanner;
